import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-32 pb-24">
        <div className="container-custom max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-serif mb-8 text-center">Privacy Policy</h1>
          <p className="text-right italic mb-8 text-softgray">Last Updated: January 2025</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">A SACRED COMMITMENT TO YOUR PRIVACY</h2>
          <p className="mb-8">In the tradition of monastic custodianship, Immaculate Industries Inc. ("we," "our," or "us") consider your privacy a sacred trust. This Privacy Policy describes how we gather, use, and protect the information you share with us through your interaction with The Monastery Method.</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">THE WISDOM OF INFORMED CONSENT</h2>
          <p className="mb-4">Just as the monastics carefully preserved knowledge through the ages, we commit to preserving your information with equal care. This Policy outlines:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">What information we collect</li>
            <li className="mb-2">How we use this information</li>
            <li className="mb-2">How we protect your information</li>
            <li className="mb-2">Your rights regarding your information</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">INFORMATION WE RECEIVE INTO OUR CARE</h2>
          <h3 className="text-lg font-medium mb-2">Application & Consultation Information</h3>
          <ul className="list-disc pl-8 mb-4">
            <li className="mb-2">Name and contact details</li>
            <li className="mb-2">Professional background</li>
            <li className="mb-2">Responses to application questions</li>
            <li className="mb-2">Scheduling preferences</li>
            <li className="mb-2">Communication during consultation</li>
          </ul>
          
          <h3 className="text-lg font-medium mb-2 mt-4">Website Visitation</h3>
          <ul className="list-disc pl-8 mb-4">
            <li className="mb-2">IP address</li>
            <li className="mb-2">Browser type</li>
            <li className="mb-2">Device information</li>
            <li className="mb-2">Pages visited</li>
            <li className="mb-2">Time spent on our website</li>
          </ul>
          
          <h3 className="text-lg font-medium mb-2 mt-4">Payment Information</h3>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">We do not collect or store payment information directly</li>
            <li className="mb-2">Payments are processed through secure third-party processors</li>
            <li className="mb-2">Only confirmation of completed transactions is received</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">THE PURPOSE BEHIND OUR STEWARDSHIP</h2>
          <p className="mb-4">We use your information with intention and purpose:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">To review your application for The Monastery Method</li>
            <li className="mb-2">To communicate about your journey and our offerings</li>
            <li className="mb-2">To schedule and conduct consultation sessions</li>
            <li className="mb-2">To provide the services you request</li>
            <li className="mb-2">To improve our offerings and communications</li>
            <li className="mb-2">To fulfill our legal and regulatory obligations</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">SHARING WITH TRUSTED COMPANIONS</h2>
          <p className="mb-4">Like monks who carefully selected those with whom they shared their manuscripts, we are selective about sharing your information:</p>
          <ul className="list-disc pl-8 mb-4">
            <li className="mb-2">Service providers who help us deliver our services (email platforms, scheduling tools)</li>
            <li className="mb-2">Professional advisors when necessary (legal, accounting)</li>
            <li className="mb-2">As required by law or to protect our rights</li>
          </ul>
          <p className="mb-8">We do not sell or rent your information to third parties.</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">SAFEGUARDING YOUR INFORMATION</h2>
          <p className="mb-4">Just as monasteries protected their treasures, we employ reasonable measures to protect your information through:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">Secure technical infrastructure</li>
            <li className="mb-2">Limited access to personal information</li>
            <li className="mb-2">Regular review of our practices</li>
            <li className="mb-2">Training for those who handle your information</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">YOUR RIGHTS IN THE DIGITAL SCRIPTORIUM</h2>
          <p className="mb-4">You maintain rights over your information:</p>
          <ul className="list-disc pl-8 mb-4">
            <li className="mb-2">Access your personal information</li>
            <li className="mb-2">Correct inaccuracies</li>
            <li className="mb-2">Request deletion (subject to legal requirements)</li>
            <li className="mb-2">Withdraw consent for future communications</li>
            <li className="mb-2">Receive an explanation of how we've used your information</li>
          </ul>
          <p className="mb-8">To exercise these rights, contact us at: [knock@themonasterymethod.com]</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">COOKIES: THE DIGITAL BREAD OF OUR TIME</h2>
          <p className="mb-4">Our website uses cookies – small files stored on your device – to improve your experience. Just as monks offered bread to travelers, these digital morsels help us:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">Remember your preferences</li>
            <li className="mb-2">Understand how you use our site</li>
            <li className="mb-2">Improve navigation and functionality</li>
          </ul>
          <p className="mb-8">You may refuse cookies through your browser settings, though this may affect your experience.</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">AMENDMENTS TO OUR RULE</h2>
          <p className="mb-4">Like the monastic rule that evolved over centuries, this Privacy Policy may be updated periodically. We will notify you of significant changes by:</p>
          <ul className="list-disc pl-8 mb-8">
            <li className="mb-2">Email (if we have your address)</li>
            <li className="mb-2">Notice on our website</li>
            <li className="mb-2">Updated "Last Modified" date</li>
          </ul>
          
          <h2 className="text-xl font-serif mb-3 mt-8">INQUIRIES AND CONTEMPLATIONS</h2>
          <p className="mb-4">For questions about this policy or to exercise your rights, please contact:</p>
          <p className="mb-2">Immaculate Industries Inc.</p>
          <p className="mb-8">[knock@themonasterymethod.com]</p>
          
          <h2 className="text-xl font-serif mb-3 mt-8">JURISDICTION AND GOVERNANCE</h2>
          <p className="mb-8">This Policy is governed by the laws of Ontario, Canada, without regard to conflict of law principles.</p>
          
          <p className="italic text-center mt-12 mb-8">"Do not be anxious about your data; we have taken it into our care with reverence."</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
